function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "arms");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "arms",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M156.4782,139.6504 C157.0452,142.1234 155.3502,144.5514 152.6852,145.1034 C152.3582,145.1814 142.5962,147.6394 131.3592,161.7904 C121.5312,174.1664 108.7962,197.9174 101.5662,241.8854 C101.8072,242.5624 102.0702,243.2494 102.3742,243.9624 C103.6512,246.9624 104.8492,249.9764 106.4012,252.8454 C107.9672,255.7404 109.7562,258.8054 110.8112,261.8904 C111.8862,265.0324 113.3132,268.9534 112.1862,272.2024 C111.0042,275.6064 106.3512,278.1754 102.7492,278.9064 C89.1952,281.6554 87.6072,266.8854 88.8052,258.2004 C89.4552,253.4894 89.9042,248.3464 91.1582,243.7244 C106.3122,145.8474 148.6992,136.4544 150.5522,136.0924 C153.2582,135.5644 155.9072,137.1594 156.4782,139.6504 Z M242.0953,139.6553 C242.6663,137.1653 245.3163,135.5693 248.0213,136.0983 C249.8743,136.4603 292.2613,145.8523 307.4153,243.7293 C308.6693,248.3523 309.1183,253.4953 309.7683,258.2063 C310.9663,266.8913 309.3783,281.6613 295.8243,278.9123 C292.2223,278.1813 287.5693,275.6123 286.3873,272.2073 C285.2593,268.9583 286.6873,265.0383 287.7613,261.8963 C288.8183,258.8113 290.6073,255.7463 292.1713,252.8513 C293.7243,249.9813 294.9223,246.9673 296.1993,243.9683 C296.5033,243.2543 296.7663,242.5673 297.0073,241.8913 C289.7773,197.9233 277.0423,174.1723 267.2143,161.7953 C255.9773,147.6453 246.2153,145.1863 245.8883,145.1083 C243.2243,144.5563 241.5293,142.1283 242.0953,139.6553 Z",
  fill: "#424242"
}));

var SvgArms = function SvgArms(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "400px",
    viewBox: "0 0 400 400",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arms.b90bd46d.svg";
export { ForwardRef as ReactComponent };